<template>
  <base-panel
    :asset="asset"
    :hide-print-button="false"
    :asset-module="assetModule"
    :tabs="tabs"
    :last-update="status.lastUpdate"
    :notifications="notifications"
  />
</template>

<script>
import IsolationAgingTabs from '@/domain/enums/installation/engineering/isolationAging/isolationAgingTabs';
import BasePanel from '@/domain/components/installation/engineering/BasePanel';
import GeneralTab from '@/domain/components/installation/engineering/isolationAging/GeneralTab';
import ChartsTab from '@/domain/components/installation/engineering/isolationAging/ChartTab';
import ParametersTab from '@/domain/components/installation/engineering/isolationAging/ParametersTab';
import Service from '@/domain/services/installation/engineering/isolationAging/isolationAgingService';
import eventBus from '@/services/globalEventBus';
import LoadingMixin from '@/services/loadingMixin';
import events from '@/domain/events/engineering';
import isolationEvents from '@/domain/events/isolationAging';
import { EndLifeIsolationCriteria } from 'sigma-mappings';

export default {
  name: 'IsolationAging',
  props: {
    asset: {
      type: Object,
      default: () => ({}),
    },
    assetModule: {
      type: Object,
      default: () => ({}),
    },
    notifications: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [LoadingMixin],
  components: {
    BasePanel,
  },
  data: () => ({
    status: {},
    selectedCriteria: EndLifeIsolationCriteria.IEEEC5791_IEC600767_NBR53567_GP_200_LIFE_150000,
  }),
  computed: {
    tabs() {
      return [
        {
          name: IsolationAgingTabs.GENERAL,
          title: this.$t('general.general'),
          component: GeneralTab,
          selectedCriteria: this.selectedCriteria,
          windingAmount: this.status.windingAmount,
          criticalTimeOccurrenceLimit: this.status.criticalTimeOccurrenceLimit,
          installationTimeZone: this.status.installationTimeZone,
        },
        {
          name: IsolationAgingTabs.PARAMETERS,
          title: this.$t('general.parameters'),
          component: ParametersTab,
          windingAmount: this.status.windingAmount,
          installationTimeZone: this.status.installationTimeZone,
        },
        {
          name: IsolationAgingTabs.CHART,
          title: this.$t('general.chart'),
          component: ChartsTab,
          selectedCriteria: this.selectedCriteria,
          windingAmount: this.status.windingAmount,
          installationTimeZone: this.status.installationTimeZone,
        },
      ];
    },
  },
  created() {
    this.initListener();
    this.getStatus(true, true);
  },
  beforeDestroy() {
    this.removeListener();
  },
  methods: {
    checkMessages() {
      if (this.status.unreliableWaterOnPaperInformation) {
        this.$pushAlert({ code: 'MA090' });
      }
      if (this.status.parametersNotConsidered) {
        this.$pushAlert({ code: 'MA091' });
      }
    },
    getStatus(showLoading, checkMessages) {
      return Service.getStatus(this.assetModule.id)
        .then((response) => {
          this.status = response;
          if (checkMessages) {
            this.checkMessages();
          }
        })
        .then(() => {
          eventBus.emit(events.refreshDataTab, showLoading);
        })
        .catch(() => {
          this.status.windingAmount = 0;
        });
    },
    setCriteria(value) {
      this.selectedCriteria = value;
    },
    initListener() {
      eventBus.on(events.refreshData, this.refreshDataEvent, this);
      eventBus.on(isolationEvents.refreshCriteria, this.setCriteria, this);
    },
    removeListener() {
      eventBus.off(events.refreshData, this.refreshDataEvent, this);
      eventBus.off(isolationEvents.refreshCriteria, this.setCriteria, this);
    },
    refreshDataEvent({ wait }) {
      wait(this.getStatus());
    },
  },
};
</script>

<style lang="sass" scoped>
  @media print
    ::v-deep .tabs > .tab-content > .tab-pane
      border-bottom: none
</style>
